import axios from "axios";
import apis from "..";



export const getAllAttendeeListApi = async (id, sort, currentPage, searchBtnValue) => {
    const token = localStorage.getItem("token").replace(/^"(.*)"$/, "$1");
    try {
        const response = await axios.get(
            `${apis.attendee.get}/${id}?limit=${sort}&page=${currentPage}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response;
    } catch (error) {
        console.error("Error creating facility:", error);
        throw error;
    }
};